{
  "DATA_ASSISTANT": {
    "TITLE": "Asistent za podatke",
    "NEW_CONVERSATION": "+ Novo",
    "LOADING": "Učitavanje...",
    "LOADING_MESSAGES": "Učitavanje poruka...",
    "THINKING": "Razmišljanje...",
    "UNTITLED": "Razgovor bez naziva",
    "NO_CONVERSATIONS": "Još uvek nema razgovora. Kliknite na \"+ Novo\" da počnete.",
    "EMPTY_STATE": "Izaberite razgovor ili napravite novi da biste počeli.",
    "PLACEHOLDER": "Šta mogu da saznam za vas?",
    "SHOW_SQL": "Prikaži SQL",
    "NO_ROWS": "Nijedan red nije vraćen.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Obriši razgovor",
    "DELETE_CONFIRM_DESCRIPTION": "Da li ste sigurni da želite da obrišete ovaj razgovor? Ova radnja se ne može poništiti.",
    "DELETE_CONFIRM_YES": "Obriši",
    "REPORTS": "Izveštaji",
    "SAVE_TO_REPORT": "Sačuvaj u izveštaj",
    "NEW_REPORT": "Novi izveštaj",
    "REPORT_NAME": "Naziv izveštaja",
    "NO_REPORTS": "Još uvek nema sačuvanih izveštaja",
    "REPORTS_EMPTY_STATE": "Izaberite izveštaj ili napravite novi.",
    "REPORT_SAVED": "Sačuvano u izveštaj",
    "DELETE_REPORT_CONFIRM": "Obriši izveštaj",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Da li ste sigurni da želite da obrišete ovaj izveštaj? Sve sačuvane stavke će biti uklonjene.",
    "DELETE_ITEM_CONFIRM": "Ukloni stavku",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Da li ste sigurni da želite da uklonite ovu stavku iz izveštaja?",
    "EXPORT_CSV": "Izvezi CSV",
    "REFRESH": "Osveži",
    "QUERY_RUNNING": "Izvršavanje upita...",
    "QUERY_FAILED": "Upit nije uspeo",
    "AUTO_REFRESH": "Automatsko osvežavanje",
    "AUTO_REFRESH_NONE": "Ručno",
    "AUTO_REFRESH_30S": "30 sekundi",
    "AUTO_REFRESH_1M": "1 minut",
    "AUTO_REFRESH_5M": "5 minuta",
    "AUTO_REFRESH_10M": "10 minuta",
    "EDIT_MESSAGE": "Izmeni poruku",
    "RENAME_REPORT": "Preimenuj izveštaj",
    "RENAME_ITEM": "Preimenuj stavku",
    "MOVE_UP": "Pomeri gore",
    "MOVE_DOWN": "Pomeri dole",
    "COLLABORATORS": {
      "BUTTON": "Saradnici",
      "TITLE": "Saradnici na izveštaju",
      "DESCRIPTION": "Izaberite koji agenti i timovi mogu da vide ovaj izveštaj.",
      "AGENTS": "Agenti",
      "TEAMS": "Timovi",
      "SELECT_AGENTS": "Izaberite agente",
      "SELECT_TEAMS": "Izaberite timove",
      "SAVE": "Sačuvaj",
      "SAVED": "Saradnici su ažurirani",
      "SAVE_FAILED": "Nije uspelo ažuriranje saradnika"
    }
  }
}
